import React from 'react';
import styled from 'styled-components';

const FloatingBtn = styled.button`
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 100;
  border: none;
  background: rgba(20, 24, 38, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #e9ecf1;
  border-radius: 999px;
  padding: 8px 16px;
  font-size: 0.88rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  transition: transform 0.12s ease;
  &:hover { transform: translateY(-1px); }
  @media (max-width: 480px) {
    top: 12px;
    left: 12px;
  }
`;

const HeaderBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #e9ecf1;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.2s ease;
  &:hover { background: rgba(255, 255, 255, 0.18); }
`;

function ArrowIcon({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export function CmBackButton({
  onClick,
  variant = 'floating', // 'floating' | 'header'
  label = '返回',
  ariaLabel,
  type = 'button',
  ...rest
}) {
  const Btn = variant === 'header' ? HeaderBtn : FloatingBtn;
  const iconSize = variant === 'header' ? 20 : 16;

  return (
    <Btn type={type} onClick={onClick} aria-label={ariaLabel || label} {...rest}>
      <ArrowIcon size={iconSize} />
      {label}
    </Btn>
  );
}

